import api from "./api";
import currentUserId from "../reduxSaga/sagas/requests/currentUserId";
import UtilsUrl from "../utils/UtilsUrl";

class Payement {
  transfertAccountShop(model) {
    return api.post(
      UtilsUrl.payementSalesURL() + "/transfertAccountShop",
      model
    );
  }
  getPayementById(idPayement) {
    return api.get(
      UtilsUrl.payementBillURL() + "/getPayementById/" + idPayement
    );
  }

  getMaxAmountBC(idBC) {
    return api.get(UtilsUrl.payementBillURL() + "/getMaxAmountBC/" + idBC);
  }
  getAmountMaxBill(idBill) {
    return api.get(
      UtilsUrl.payementBillURL() + "/getAmountMaxToPayBill/" + idBill
    );
  }

  getRetenuSourcePDF(idBill) {
    return api.get(UtilsUrl.retenuURL() + "/genererRetenu/" + idBill);
  }

  getRetenuSourceBillSellPDF(idBill) {
    return api.get(UtilsUrl.retenuURL() + "/genererRetenuBillSell/" + idBill);
  }

  findChequeTraiteByRef(idUser, ref) {
    return api.get(
      UtilsUrl.payementAchatURL() + "/findChequeTraiteByRef/" + idUser + "/" + ref
    );
  }


    echangePayementTraite(model) {
    return api.post(
      UtilsUrl.payementAchatURL() + "/echangePayementTraite",model
    );
  }
}
export default new Payement();
